import { useEffect, useState } from "react";
import publisher from "./publisherList.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import report from "../../assets/images/download-report.png";

const AllPubList = () => {
  const [allPubData, setAllPubData] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
    const allPubList = async () => {
      try {
      const token = localStorage.getItem("token"); 
      const allPubListRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/getAllPublishers` , {
        headers : {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      if(allPubListRes.status === 200) {
        setAllPubData(allPubListRes.data.data);
      }else {
        setMessage("No domains found.");
      }
      
    } catch (error){
       setMessage("Error fetching domain list.");
        if (error.response?.status === 401) {
          console.error("Unauthorized! Token might be expired.");
          localStorage.removeItem("token");
          navigate("/");
        } else {
          console.error("Error fetching data:", error);
        }
    }
  }
  useEffect(()=>{
    allPubList();
  },[]);
  return (
    <section className="mainContainer">
      <div className="container mt-4">
        <h4>Publisher List</h4>
        {message && <div className="alert alert-info">{message}</div>}
      <table className="table table-striped table-hover table-bordered">
                <thead>
            <tr>
              <th scope="col">S.N </th>
              <th scope="col">Account Name</th>
              <th scope="col">Company Name</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {
              allPubData?.length > 0 ? (
                allPubData.map((pubList, pubListInd) =>(
                  <tr key={pubListInd}>
                    <td>{pubListInd + 1}</td>
                    <td>{pubList?.account_name}</td>
                    <td>{pubList?.company_name}</td>
                    <td>
                        <button
                        className="btn btn-primary btn-md"
                        onClick={() => navigate(`/edit-publisher/${pubList.account_id}`)}
                      >
                        Edit
                      </button>
                      &nbsp;
                    <button
                      className="btn btn-success btn-md"
                      onClick={() => navigate(`/domain-list/${pubList.account_id}`)}
                    >
                      Domain List
                    </button>
                    </td>
                  </tr>
                ))
              ) : 
              <tr>
                <td colSpan="12" className="text-center">No data available</td>
              </tr>
            }
          </tbody>
      </table>
      </div>
    </section>
  )
};

export default AllPubList;
